import React from 'react';

export default function InfoArticle({
  label,
  value,
  muted,
}: {
  label: string;
  value: React.ReactNode;
  muted?: boolean;
}) {
  return (
    <article>
      <p className='text-overlay mb-1 text-muted text-sm'>{label}</p>
      <span className={`text-sm font-medium`}>{value}</span>
    </article>
  );
}
